import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M9 8v6h2V8a4 4 0 014-4h2a4 4 0 014 4 1 1 0 002 0 6 6 0 00-6-6h-2a6 6 0 00-6 6z"/><path d="M25 14H7a2 2 0 00-2 2v12a2 2 0 002 2h18a2 2 0 002-2V16a2 2 0 00-2-2zm-9 12a2 2 0 01-2-2 2 2 0 011-1.7V19a1 1 0 012 0v3.3a2 2 0 011 1.7 2 2 0 01-2 2z"/>';
export var UnlockSVG = function UnlockSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
UnlockSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(UnlockSVG);